import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from './Component/Navbar';
import Home from './Component/Home';
import Features from './Component/Features';
import Footer from './Component/Footer';
import Pricing from './Component/Pricing';
import About from './Component/About';
import Contact from './Component/Contact';
import PrivacyPolicy from './Component/PrivacyPolicy';
import TermsConditions from './Component/Terms&Conditions';
import RefundPolicy from './Component/RefundPolicy';

function App() {
  return (
    <Router>
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/about' element={< About/>}/>
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing/>}/>
        <Route path='/contact' element={< Contact/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path='/termsconditions' element={<TermsConditions/>}/>
        <Route path='/refundpolicy' element={<RefundPolicy/>}/>
      </Routes>
      
      <Footer />
    </Router>
  );
}

export default App;